'use memo'

import {
  AgxButton,
  AgxModal,
  AgxSpacer,
  AgxTypography,
} from '@urbanx/agx.ui-components2'

interface TaskStepCompletionConfirmationModalProps {
  isOpen: boolean
  taskLabel: string
  stageTransitionWarning?: boolean
  onCancel: () => void
  onConfirm: () => void
}

const TaskStepCompletionConfirmationModal = ({
  isOpen,
  taskLabel,
  stageTransitionWarning = false,
  onCancel,
  onConfirm,
}: TaskStepCompletionConfirmationModalProps) => {
  if (!isOpen) return null

  const actionButtons = (
    <AgxSpacer gap="spacing-md" contentJustification="center" direction="horizontal">
      <AgxButton
        id="cancel-step-completion"
        text="Cancel"
        variant="hollow"
        onClick={onCancel}
        stretch
      />
      <AgxButton
        id="confirm-step-completion"
        text="Confirm"
        variant="primary"
        onClick={onConfirm}
        stretch
      />
    </AgxSpacer>
  )

  return (
    <AgxModal
      id="confirm-step-completion-modal"
      title={`Confirm ${taskLabel} Satisfied`}
      type="dialog"
      variant="withDivider"
      actionButtonContainerStyle="withoutDivider"
      setIsDialogOpen={(nextIsOpen) => {
        if (!nextIsOpen) onCancel()
      }}
      isOpen
      minWidth="480px"
      content={
        <AgxSpacer
          direction="vertical"
          gap="spacing-md"
          padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
        >
          <AgxTypography
            id="confirm-step-completion-message"
            type="body_ui"
            size="small"
          >
            {`Completing this will mark the ${taskLabel} task as satisfied.`}
          </AgxTypography>
          {stageTransitionWarning && (
            <AgxSpacer direction="vertical" padding={{ bottom: 'md' }}>
              <AgxTypography
                id="confirm-step-completion-unconditional-warning"
                type="body_ui_strong"
                size="small"
              >
                This action will transition the contract to unconditional!
              </AgxTypography>
            </AgxSpacer>
          )}
          <AgxTypography
            id="confirm-step-completion-irreversible-warning"
            type="body_ui"
            size="small"
          >
            This action cannot be undone. Do you wish to continue?
          </AgxTypography>
        </AgxSpacer>
      }
      actionButtons={actionButtons}
    />
  )
}

export default TaskStepCompletionConfirmationModal
